/**
 * Defined hard-coded CSS classes using through the app.
 */

// Apply on some icons in the actions columns to be always displayed
export const tableIconDontHide = 'tableIconDontHide'
